import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import PackageInfo from '../entities/handoversessionpackageinfo'
import Ajax from '../../lib/ajax'

interface HandoverSessionPackagesState extends ListState<PackageInfo> {
    deliveryPackages: Array<PackageInfo>,
}
class HandoverSessionPackagesModule extends ListModule<HandoverSessionPackagesState, any, PackageInfo>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 5,
        list: new Array<PackageInfo>(),
        loading: false,
        deliveryPackages: new Array<PackageInfo>()
    }
    actions = {
        async getAll(context: ActionContext<HandoverSessionPackagesState, any>, payload: any) {
           context.state.totalCount = context.state.deliveryPackages.length;
        },
        async get(context: ActionContext<HandoverSessionPackagesState, any>, payload: any) {
            return new PackageInfo();
        }
    };
    mutations = {
        setCurrentPage(state: HandoverSessionPackagesState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: HandoverSessionPackagesState, pagesize: number) {
            state.pageSize = pagesize;
        },
        resetList(state: HandoverSessionPackagesState) {
            state.list = new Array<PackageInfo>();
            state.deliveryPackages = new Array<PackageInfo>();
            state.currentPage = 1;
            state.pageSize = 5;
        },
    }
}
const handoverSessionPackagesModule = new HandoverSessionPackagesModule();
export default handoverSessionPackagesModule;